import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/manrope/wght.css";
import { App } from "./App";
import "./styles.css";

const root = document.getElementById("root");
if (root === null) throw new Error("SportTrack root element is missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
